import React from "react";
import "../LandingPage/landing.css";
import {MaintenanceCopy} from "../../components/MaintenanceNotice";

/**
 * Rendered for every /app/* route while MAINTENANCE_MODE is on. Static: no
 * providers, no API calls, so a paused backend never gets hit.
 */
const MaintenancePage: React.FC = () => (
    <main className="lp min-h-screen bg-[var(--paper)] text-[var(--ink)] flex flex-col">
        <header className="px-6 sm:px-10 py-6 border-b border-[var(--line)]">
            <a href="/" className="lp-serif text-[26px] tracking-tight">LoA</a>
        </header>
        <div className="flex-1 flex items-center justify-center px-6 py-16">
            <div className="w-full max-w-[520px]">
                <MaintenanceCopy/>
                <a href="/" className="mt-8 inline-block text-[14px] text-[var(--ink-3)] hover:text-[var(--ink)] transition">
                    &larr; Back to loa-ai.com
                </a>
            </div>
        </div>
    </main>
);

export default MaintenancePage;
